<white-card>
  <page-header-actions>
    <page-title labelKey="ORDERS.LABEL"></page-title>
    <ng-container buttons>
      <button *ngIf="store.hasTaskReleaseRole()" mat-flat-button color="primary" (click)="add()">
        <mat-icon>add</mat-icon>
        {{ 'ORDERS.ADD' | translate }}
      </button>
      <button mat-flat-button (click)="store.refreshOrders()">
        <mat-icon>refresh</mat-icon>
        {{ 'REFRESH_DATA' | translate }}
      </button>
      <button mat-icon-button [matMenuTriggerFor]="dictionariesMenu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #dictionariesMenu="matMenu">
        <button *ngIf="store.hasTaskReleaseRole()" mat-menu-item (click)="add()">
          <mat-icon class="material-icons-outlined" fontIcon="add"></mat-icon>
          {{ 'ORDERS.ADD' | translate }}
        </button>
        <button mat-menu-item (click)="grid.reset()">
          <mat-icon class="material-icons-outlined" fontIcon="filter_alt_off"></mat-icon>
          {{ 'CLEAR_FILTERS' | translate }}
        </button>
        <button mat-menu-item (click)="grid.exportXLS()">
          <mat-icon class="material-icons-outlined" fontIcon="get_app"></mat-icon>
          {{ 'EXPORT_XLS' | translate }}
        </button>
      </mat-menu>
    </ng-container>
  </page-header-actions>
  <mat-button-toggle-group [value]="ordersListMode$ | async" (change)="changeMode($event)">
    <mat-button-toggle [value]="LIST_SEARCH_MODE.EXTERNAL">{{ LIST_SEARCH_MODE.EXTERNAL | translate }}</mat-button-toggle>
    <mat-button-toggle [value]="LIST_SEARCH_MODE.ACTIVE">{{ LIST_SEARCH_MODE.ACTIVE | translate }}</mat-button-toggle>
    <mat-button-toggle [value]="LIST_SEARCH_MODE.ARCHIVED">{{ LIST_SEARCH_MODE.ARCHIVED | translate }}</mat-button-toggle>
    <mat-button-toggle [value]="LIST_SEARCH_MODE.ALL">{{ LIST_SEARCH_MODE.ALL | translate }}</mat-button-toggle>
  </mat-button-toggle-group>
  <grid-master
      #grid
      [rowData]="orders$ | async"
      [columnDefs]="columnDefs"
      [context]="{ ordersListMode: ordersListMode$ | async }"
      headersKey="ORDERS_GRID"
      (rowClickedEvent)="rowClicked($event)"
      [rowHover]="true"
      [sizeColumnsToFit]="true"
  >
  </grid-master>
</white-card>
